import React, {useEffect} from "react";

import {useStoreActions, useStoreState} from 'easy-peasy';
import { Col, Row } from "react-bootstrap";

import ApkFormComponent from "../../components/apks/ApkFormComponent";
import useBackButton from "../../hooks/useBackButton";
import { useParams } from "react-router-dom";
import Loader from "../../components/widgets/Loader";


const UpdateApkPage = () => {

    const { backButtonComponent } = useBackButton();

    const { fetchApkById, updateApk } = useStoreActions(actions => actions.apks);
    const { apkById, isFetchingOneApk } = useStoreState(state => state.apks);
	
	const { uniqueId } = useParams();

	useEffect(() => {
		if (uniqueId) {
			fetchApkById(uniqueId);
		}
	}, [uniqueId]);

	return (
		<div className="container p-2">
			<Row className="mb-3">
				<Col className="d-flex justify-content-between align-items-center">
                    <h2>Mise à jour de l'apk {apkById?.originalName}</h2>
					{backButtonComponent}
				</Col>
			</Row>
			{isFetchingOneApk || !apkById ?
				<Loader />
				: <ApkFormComponent 
					actionFn={updateApk}
					apk={apkById}
				/>
            }
		</div>
	);
};

export default UpdateApkPage;
